import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { providers } from 'ethers';
import detectEthereumProvider from '@metamask/detect-provider';
import { Event } from '../../../../helpers/event';
var GET_METAMASK_LINK = 'https://metamask.io/download.html';
export function getMetamaskProvider() {
  return _getMetamaskProvider.apply(this, arguments);
}
function _getMetamaskProvider() {
  _getMetamaskProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _a, injectedProviders, injectedProvider, provider;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          if (window.ethereum) {
            _context5.next = 3;
            break;
          }
          window.open(GET_METAMASK_LINK);
          return _context5.abrupt("return", undefined);
        case 3:
          injectedProviders = (window === null || window === void 0 ? void 0 : window.ethereum.providers) || [];
          if (!((_a = injectedProviders.find(function (provider) {
            var _a;
            return (_a = provider.isMetaMask) !== null && _a !== void 0 ? _a : false;
          })) !== null && _a !== void 0)) {
            _context5.next = 8;
            break;
          }
          _context5.t0 = _a;
          _context5.next = 11;
          break;
        case 8:
          _context5.next = 10;
          return detectEthereumProvider();
        case 10:
          _context5.t0 = _context5.sent;
        case 11:
          injectedProvider = _context5.t0;
          if (injectedProvider) {
            _context5.next = 15;
            break;
          }
          console.log("Metamask is not installed - you can get it under ".concat(GET_METAMASK_LINK));
          return _context5.abrupt("return", undefined);
        case 15:
          provider = new providers.Web3Provider(injectedProvider, 'any');
          return _context5.abrupt("return", provider);
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _getMetamaskProvider.apply(this, arguments);
}
export var MetamaskConnector = /*#__PURE__*/function () {
  function MetamaskConnector() {
    _classCallCheck(this, MetamaskConnector);
    this.name = 'Metamask';
    this.update = new Event();
  }
  _createClass(MetamaskConnector, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var metamask;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.provider) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return getMetamaskProvider();
            case 4:
              metamask = _context.sent;
              if (metamask) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              this.provider = metamask;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "connectEagerly",
    value: function () {
      var _connectEagerly = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var chainId, accounts;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.init();
            case 2:
              if (this.provider) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              _context2.prev = 4;
              _context2.next = 7;
              return this.provider.send('eth_chainId', []);
            case 7:
              chainId = _context2.sent;
              _context2.next = 10;
              return this.provider.send('eth_accounts', []);
            case 10:
              accounts = _context2.sent;
              this.update.emit({
                chainId: parseInt(chainId),
                accounts: accounts
              });
              _context2.next = 17;
              break;
            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](4);
              console.debug(_context2.t0);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 14]]);
      }));
      function connectEagerly() {
        return _connectEagerly.apply(this, arguments);
      }
      return connectEagerly;
    }()
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _a, chainId, accounts;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.init();
            case 2:
              if (this.provider) {
                _context3.next = 4;
                break;
              }
              throw new Error('Could not activate connector');
            case 4:
              _context3.prev = 4;
              _context3.next = 7;
              return this.provider.send('eth_chainId', []);
            case 7:
              chainId = _context3.sent;
              _context3.next = 10;
              return this.provider.send('eth_requestAccounts', []);
            case 10:
              accounts = _context3.sent;
              this.update.emit({
                chainId: parseInt(chainId),
                accounts: accounts
              });
              _context3.next = 18;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              console.log(_context3.t0);
              throw new Error('Could not activate connector: ' + ((_a = _context3.t0.message) !== null && _a !== void 0 ? _a : ''));
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 14]]);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "deactivate",
    value: function () {
      var _deactivate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.provider = undefined;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deactivate() {
        return _deactivate.apply(this, arguments);
      }
      return deactivate;
    }()
  }]);
  return MetamaskConnector;
}();